<template>
  <v-dialog v-model="isDialogOpenCreate" max-width="700px">
    <v-card>
      <v-card-title class="text-h6 font-weight-bold">
        Tambah Item
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="formCreate" v-model="isFormValidCreate">
          <v-row dense>
            <!-- NAME -->
            <v-col cols="6">
              <v-text-field
                v-model="name"
                label="Nama Item"
                outlined
                dense
                :rules="[(v) => !!v || 'Wajib diisi']"
              />
            </v-col>

            <v-col cols="6" md="6">
              <v-autocomplete
                :items="listCategory"
                item-text="name"
                item-value="id"
                label="Kategori"
                outlined
                dense
                v-model="selectedCategoryId"
              />
            </v-col>

            <!-- <v-col cols="6" md="6">
              <v-autocomplete
                :items="listBrand"
                item-text="name"
                item-value="id"
                label="Brand"
                outlined
                dense
                v-model="selectedBrandId"
              />
            </v-col>

            <v-col cols="6" md="6">
              <v-autocomplete
                :items="listColor"
                item-text="name"
                item-value="id"
                label="Warna"
                outlined
                dense
                v-model="selectedColorId"
              />
            </v-col> -->

            <!-- <v-col cols="6" md="6">
              <v-autocomplete
                :items="listMaterial"
                item-text="name"
                item-value="id"
                label="Material"
                outlined
                dense
                v-model="selectedMaterialId"
              />
            </v-col> -->

            <!-- <v-col cols="6" md="6">
              <v-autocomplete
                :items="listUom"
                item-text="name"
                item-value="id"
                label="UOM"
                outlined
                dense
                v-model="selectedUomId"
              />
            </v-col> -->

            <!-- <v-col cols="6" md="6">
              <v-autocomplete
                :items="listTypeAsset"
                item-text="name"
                item-value="id"
                label="Tipe Asset"
                outlined
                dense
                v-model="selectedTypeAssetId"
              />
            </v-col> -->

            <!-- NOTE -->
            <v-col cols="12">
              <v-textarea
                v-model="note"
                label="Catatan"
                outlined
                dense
                rows="2"
                auto-grow
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="isDialogOpenCreate = false"> Batal </v-btn>

        <v-btn
          color="primary"
          :disabled="!isFormValidCreate"
          @click="submitCreate"
        >
          Simpan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/utils/api";
import store from "@/store";

export default {
  name: "DialogItem",

  data() {
    return {
      // MASTER
      listCategory: [],
      listBrand: [],
      listColor: [],
      listMaterial: [],
      listUom: [],
      listTypeAsset: [],

      // FORM
      id: null,
      name: null,
      uom_id: null,
      note: null,
      selectedCategoryId: null,
      selectedBrandId: null,
      selectedColorId: null,
      selectedMaterialId: null,
      selectedUomId: null,
      selectedTypeAssetId: null,

      // UI
      isDialogOpenCreate: false,
      isFormValidCreate: false,
      isLoadingSubmit: false,

      // VALIDATION
      rules: {
        required: [(v) => !!v || "Field wajib diisi"],

        requiredNumber: [
          (v) =>
            v !== null && v !== "" && v !== undefined
              ? true
              : "Field wajib diisi",
        ],
      },
    };
  },

  methods: {
    fetchCategory() {
      api
        .get("/categories")
        .then(({ data }) => {
          this.listCategory = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchBrand() {
      api
        .get("/brand")
        .then(({ data }) => {
          this.listBrand = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching brand:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchColor() {
      api
        .get("/color")
        .then(({ data }) => {
          this.listColor = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching color:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchMaterial() {
      api
        .get("/material")
        .then(({ data }) => {
          this.listMaterial = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching material:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchUom() {
      api
        .get("/uom")
        .then(({ data }) => {
          this.listUom = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching uom:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchTypeAsset() {
      api
        .get("/typeasset")
        .then(({ data }) => {
          this.listTypeAsset = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching typeasset:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    // =========================
    // OPEN DIALOG
    // =========================
    openDialogCreate(payload = {}) {
      this.resetForm();
      this.id = payload.item_id || null;
      this.name = payload.searchItem;

      this.isDialogOpenCreate = true;
    },

    // =========================
    // RESET FORM
    // =========================
    resetForm() {
      this.id = null;
      this.name = null;
      this.uom_id = null;
      this.note = null;
      this.selectedCategoryId = null;
      this.selectedBrandId = null;
      this.selectedColorId = null;
      this.selectedMaterialId = null;
      this.selectedUomId = null;
      this.selectedTypeAssetId = null;
      this.isFormValidCreate = false;

      this.$nextTick(() => {
        if (this.$refs.formCreate) {
          this.$refs.formCreate.resetValidation();
        }
      });
    },

    // =========================
    // SUBMIT CREATE
    // =========================
    async submitCreate() {
      const isValid = this.$refs.formCreate.validate();

      if (!isValid) return;

      this.isLoadingSubmit = true;

      store.dispatch("showLoading");

      try {
        const payload = {
          name: this.name,
          category_id: this.selectedCategoryId,
          brand_id: this.selectedBrandId,
          color_id: this.selectedColorId,
          material_id: this.selectedMaterialId,
          uom_id: this.selectedUomId,
          type_asset_id: this.selectedTypeAssetId,
          note: this.note,
        };

        const response = await api.post("/items", payload);

        const message = response.data.message || "Berhasil menambahkan data";

        // emit ke parent
        this.$emit("success", response.data);

        // close dialog
        this.isDialogOpenCreate = false;

        // reset form
        this.resetForm();

        // snackbar
        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: true,
        });
      } catch (error) {
        let message = "Gagal menambahkan data!";

        if (error.response) {
          message = error.response.data.message || message;
        } else {
          message = error.message || message;
        }

        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: false,
        });
      } finally {
        this.isLoadingSubmit = false;

        store.dispatch("hideLoading");
      }
    },
  },

  mounted() {
    this.fetchCategory();
    this.fetchBrand();
    this.fetchColor();
    this.fetchMaterial();
    // this.fetchUom();
    this.fetchTypeAsset();
  },
};
</script>
